import { render, staticRenderFns } from "./noteAssignComponent.vue?vue&type=template&id=f3933ba4&"
import script from "./noteAssignComponent.vue?vue&type=script&lang=js&"
export * from "./noteAssignComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports